import { CouponManagementState } from '../initial.state';
import { CouponManageActionTypes } from '../actions/couponsManagement.actions';

function CouponManagementReducer(state = new CouponManagementState(), action) {
  switch (action.type) {
    case CouponManageActionTypes.LOAD_COUPONS_SUCCESS:
      return {
        ...state,
        coupons: action.payload.data,
      };

    case CouponManageActionTypes.ADD_COUPON_SUCCESS:
      return {
        ...state,
      };

    case CouponManageActionTypes.UPDATE_COUPON_SUCCESS:
      return {
        ...state,
      };

    case CouponManageActionTypes.LOAD_CATALOGUE_SUCCESS:
      return {
        ...state,
        catalogues: action.payload.data,
      };

    default:
      return state;
  }
}

export { CouponManagementReducer };
